import {
  Col,
  Row,
  Label,
  Input,
  UncontrolledAlert,
} from "reactstrap"
import ReactSelectOption from '../../../../components/SelectOptions/ReactSelectOption';
import OnIcon from '../../../../components/OnIcon/OnIcon';
import OffIcon from '../../../../components/OffIcon/OffIcon';
import Switch from "react-switch"
import { useSelector } from 'react-redux';
import BankAccountInput from '../../../../components/Inputs/BankAccountInput';

export default function LevelThreeRequirementsForm({
  data,
  onChange,
  onSelectOptionChange,
  isDisabledFields,
  onSwitcherChange,
  currencies,
  payoutMethods,
  holderTypes,
  banks,
  onBankSelectOptionChange,
  selectedBankAccount,
  validationData = null,
  _routingTypes,
  isInvalid = () => { },
}) {

  const { accountTypes, routingTypes, countries } = useSelector(state => state.Main);
  const checkAbaIsSisabled = () => {

    if (countries && countries.length && data.levelThree?.countryId && data.levelThree?.currencyId && currencies && currencies.length) {
      let country = countries.find(el => el.id === data.levelThree?.countryId && el.name === "United States");
      let currency = currencies.find(currency => currency.id === data.levelThree?.currencyId && currency.name === "USD");

      if (!country || !currency) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  return (
    <Col sm={12}>
      <Row>
        <Col sm={12} className='mb-3'>
          {
            data.levelThree.isApproved ?

              <UncontrolledAlert color="success" role="alert" className=' mb-0'>
                <i className="mdi mdi-alert-outline me-2"></i>
                This bank account has been approved by Cryllex admin.
              </UncontrolledAlert>
              :
              <UncontrolledAlert color="danger" role="alert" className=' mb-0'>
                <i className="mdi mdi-alert-outline me-2"></i>
                Inactive bank account, awaiting approval from Cryllex administration.
              </UncontrolledAlert>
          }
        </Col>
        <Col lg={12}>
          <Row>
            {
              validationData && validationData.account_name ?
                <Col lg={4} md={6} className='order-md-first'>
                  <BankAccountInput
                    id="accountName"
                    labelValue="Account Name"
                    required={validationData.account_name?.required}
                    type={validationData.account_name.type}
                    value={data.levelThree?.accountName || ""}
                    placeholder="e.g. Cryllex"
                    pattern={validationData.account_name?.pattern}
                    error={isInvalid("levelThree", "accountName")}
                    errorMessage={validationData.account_name?.enMessage}
                    onChange={event => onChange(event, "levelThree", "accountName")}
                  />
                </Col>
                :
                <Col lg={4} md={6} className='order-md-first'>
                  <Label htmlFor='accountName' className='text-muted text-truncate mb-0'>Account Name*</Label>
                  <Input
                    id="accountName"
                    type="text"
                    placeholder='e.g. ABC Corporation'
                    className={`form-control`}
                    value={data.levelThree?.accountName || ""}
                    onChange={event => onChange(event, "levelThree", "accountName")}
                  />
                </Col>
            }
            <Col lg={12}>
              <UncontrolledAlert color="warning" role="alert" className='mt-3 mb-0'>
                <i className="mdi mdi-alert-outline me-2"></i>
                Attention: Your legal business name is linked to your bank account, and any changes made to
                the bank account name will automatically update your business name as well.
              </UncontrolledAlert>
            </Col>
            <Col lg={8} md={6} className='order-first'>
              <div className='d-flex flex-column align-items-end'>
                <Label htmlFor='countryId' className='mt-3 mb-0'>
                  {/* {`${data.levelThree.isApproved ? "Reject " : "Approve "} bank account`} */}
                  Bank account validity status
                </Label>
                <div className='mt-1'>
                  <Switch
                    className="react-switch mt-1"
                    size={1}
                    checkedIcon={<OnIcon />}
                    uncheckedIcon={<OffIcon />}
                    checked={data.levelThree.isApproved || false}
                    aria-labelledby="neat-label"
                    disabled={isDisabledFields}
                    onChange={() => onSwitcherChange(!data.levelThree.isApproved, "levelThree", "isApproved")}
                  />
                </div>
              </div>
              <hr className='d-md-none d-block' />
            </Col>
          </Row>
        </Col>
        <Col sm={12}><hr /></Col>
        {
          validationData && validationData.account_no ?

            <Col lg={4} md={6} className="mb-4">
              <BankAccountInput
                id="accountNumber"
                labelValue="Account Number"
                required={validationData.account_no?.required}
                type={validationData.account_no.type}
                value={data.levelThree?.accountNumber || ""}
                placeholder='e.g. 1234567890'
                pattern={validationData.account_no?.pattern}
                error={isInvalid("levelThree", "accountNumber")}
                errorMessage={validationData.account_no?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "accountNumber")}
              />
            </Col>
            :
            <Col lg={4} md={6} className="mb-4">
              <Label htmlFor='accountNumber' className={`text-muted text-truncate mb-0`}>Account Number*</Label>
              <Input
                id="accountNumber"
                type="text"
                placeholder='e.g. 1234567890'
                className={`form-control`}
                value={data.levelThree?.accountNumber || ""}
                onChange={(event) => onChange(event, "levelThree", "accountNumber")}
              />
            </Col>
        }
        {
          validationData && validationData.swift_code ?

            <Col lg={4} md={6} className="mb-4">
              <BankAccountInput
                id="swiftCode"
                labelValue="SWIFT Code"
                required={validationData.swift_code?.required}
                type={validationData.swift_code.type}
                value={data.levelThree.swiftCode || ""}
                placeholder='e.g. AAAA-BB-CC-DDD (BOFAUS6NGFX)'
                pattern={validationData.account_no?.pattern}
                disabled={selectedBankAccount}
                error={isInvalid("levelThree", "swiftCode")}
                errorMessage={validationData.swift_code?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "swiftCode")}
              />
            </Col>
            :
            <Col lg={4} md={6} className="mb-4">
              <Label htmlFor='swiftCode' className='text-muted text-truncate mb-0'>Swift Code*</Label>
              <Input
                id="swiftCode"
                type="text"
                className={`form-control`}
                disabled={selectedBankAccount}
                placeholder='e.g. AAAA-BB-CC-DDD (BOFAUS6NGFX)'
                value={data.levelThree?.swiftCode || ""}
                onChange={(event) => onChange(event, "levelThree", "swiftCode")}
              />
            </Col>
        }
        {
          validationData && validationData.iban ?
            <Col lg={4} md={6} className="mb-4">
              <BankAccountInput
                id="iBan"
                labelValue="iBan"
                required={validationData.iban?.required}
                type={validationData.iban.type}
                value={data.levelThree?.iBan || ""}
                placeholder='e.g. DE89 3704 0044 0532 0130 00'
                pattern={validationData.iban?.pattern}
                error={isInvalid("levelThree", "iBan")}
                errorMessage={validationData.iban?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "iBan")}
              />
            </Col>
            : <Col lg={4} md={6} className="mb-4">
              <Label htmlFor='iBan' className='text-muted text-truncate mb-0'>iBan</Label>
              <Input
                id="iBan"
                type="text"
                className={`form-control`}
                placeholder='e.g. DE89 3704 0044 0532 0130 00'
                value={data.levelThree?.iBan || ""}
                onChange={(event) => onChange(event, "levelThree", "iBan")}
              />
            </Col>
        }

      </Row>
      <hr className='mt-0' />
      <Row>
        {
          // countrySpinnerArr && countrySpinnerArr.length ?
          //   <Col sm={12}>
          //     <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "100px", }}>
          //       <PuffLoader size={50} color={SPINNER_COLOR} />
          //     </div>
          //   </Col>
          //   :
          <Col sm={12}>
            <Row>
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='countryId' className='text-muted text-truncate mb-0'>Country*</Label>
                <ReactSelectOption
                  value={data.levelThree.countryId}
                  isSearchable={true}
                  className={``}
                  selectedValue={(() => {
                    const selectedValue = { ...countries.find(item => item.id === data.levelThree.countryId) };
                    if (Object.keys(selectedValue)?.length) {
                      selectedValue.label = selectedValue.name;
                      selectedValue.value = selectedValue.id;
                      return selectedValue;
                    } else {
                      return { label: "Choose...", value: "" }
                    }
                  })()}
                  items={countries.map(item => ({ label: item.name, value: item.id }))}
                  onChange={(item) => onSelectOptionChange(item.value, "levelThree", "countryId")}
                />
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='paymentMethodLibraryDataId' className='text-muted text-truncate mb-0'>Payout method*</Label>
                <ReactSelectOption
                  value={data.levelThree?.paymentMethodLibraryDataId}
                  isSearchable={true}
                  // className={`${(isInvalidSubmit && !data.levelThree?.paymentMethodLibraryDataId) ? "error-border" : ""}`}
                  selectedValue={(() => {
                    const selectedValue = { ...payoutMethods.find(item => item.id === data.levelThree?.paymentMethodLibraryDataId) };

                    if (Object.keys(selectedValue)?.length) {
                      selectedValue.label = selectedValue.displayName;
                      selectedValue.value = selectedValue.id;
                      return selectedValue;
                    } else {
                      return { label: "Choose...", value: "" }
                    }
                  })()}
                  items={payoutMethods.map(data => ({ label: data.displayName, value: data.id }))}
                  onChange={(item) => onSelectOptionChange(item.value, "levelThree", "paymentMethodLibraryDataId")}
                />
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='holderTypeLibraryDataId' className='text-muted text-truncate mb-0'>Holder type*</Label>
                <ReactSelectOption
                  value={data.levelThree?.holderTypeLibraryDataId}
                  isSearchable={true}
                  // className={`${(isInvalidSubmit && !data.levelThree?.holderTypeLibraryDataId) ? "error-border" : ""}`}
                  selectedValue={(() => {
                    const selectedValue = { ...holderTypes.find(item => item.id === data.levelThree?.holderTypeLibraryDataId) };

                    if (Object.keys(selectedValue)?.length) {
                      selectedValue.label = selectedValue.displayName;
                      selectedValue.value = selectedValue.id;
                      return selectedValue;
                    } else {
                      return { label: "Choose...", value: "" }
                    }
                  })()}
                  items={holderTypes.map(data => ({ label: data.displayName, value: data.id }))}
                  onChange={(item) => onSelectOptionChange(item.value, "levelThree", "holderTypeLibraryDataId")}
                />
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='currencyId' className='text-muted text-truncate mb-0'>Currencies*</Label>
                <ReactSelectOption
                  value={data.levelThree?.currencyId}
                  isSearchable={true}
                  selectedValue={(() => {
                    const selectedValue = { ...currencies.find(item => item.id === data.levelThree?.currencyId) };
                    if (Object.keys(selectedValue)?.length) {
                      selectedValue.label = selectedValue.name;
                      selectedValue.value = selectedValue.id;
                      return selectedValue;
                    } else {
                      return { label: "Choose...", value: "" }
                    }
                  })()}
                  items={currencies.map(data => ({ label: data.name, value: data.id }))}
                  onChange={(item) => onSelectOptionChange(item.value, "levelThree", "currencyId")}
                />
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='routingTypeLibraryDataId' className='text-muted text-truncate mb-0'>Routing Type*</Label>
                {/* <ReactSelectOption
                  value={data.levelThree?.routingTypeLibraryDataId}
                  isSearchable={true}
                  selectedValue={(() => {
                    const selectedValue = { ...(routingTypes?.libraryData || []).find(item => item.id === data.levelThree?.routingTypeLibraryDataId) };
                    if (Object.keys(selectedValue).length) {
                      selectedValue.label = selectedValue.displayName;
                      selectedValue.value = selectedValue.id;
                      return selectedValue;
                    } else {
                      return { label: "Choose...", value: "" }
                    }
                  })()}
                  items={(_routingTypes || []).map(item => ({ label: item, value: item }))}
                  // onChange={(item) => onSelectOptionChange(item.value, "routingTypeLibraryDataId")}
                  onChange={(item) => {
                    _setRoutingType(item.value);
                  }}
                /> */}
                <ReactSelectOption
                  value={data.levelThree?.routingTypeName}
                  isSearchable={true}
                  selectedValue={(() => {
                    if (routingTypes?.libraryData.find(el => el.id === data.levelThree?.routingTypeLibraryDataId)) {
                      const selectedValue = { ...(routingTypes?.libraryData || []).find(el => el.id === data.levelThree?.routingTypeLibraryDataId) };
                      if (Object.keys(selectedValue).length) {
                        selectedValue.label = selectedValue.displayName;
                        selectedValue.value = selectedValue.id;
                        return selectedValue;
                      } else {
                        return { label: "Choose...", value: "" }
                      }
                    } else {
                      const selectedValue = (_routingTypes || []).find(el => el === data.levelThree?.routingTypeName);
                      if (selectedValue) {
                        return { label: selectedValue, value: selectedValue }
                      } else {
                        return { label: "Choose...", value: "" }
                      }
                    }
                  })()}
                  items={(_routingTypes || []).map(data => ({ label: data, value: data }))}
                  onChange={(item) => onSelectOptionChange(item.value, "levelThree", "routingTypeName")}
                />
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='accountType' className='text-muted text-truncate mb-0'>Account Type*</Label>
                <ReactSelectOption
                  value={data.levelThree?.accountType}
                  isSearchable={true}
                  selectedValue={(() => {
                    const selectedValue = { ...(accountTypes?.libraryData || []).find(item => item.id === data.levelThree?.accountType) };
                    if (Object.keys(selectedValue)?.length) {
                      selectedValue.label = selectedValue.displayName;
                      selectedValue.value = selectedValue.id;
                      return selectedValue;
                    } else {
                      return { label: "Choose...", value: "" }
                    }
                  })()}
                  items={(accountTypes?.libraryData || []).map(data => ({ label: data.displayName, value: data.id }))}
                  onChange={(item) => onSelectOptionChange(item.value, "levelThree", "accountType")}
                />
              </Col>
              {
                validationData && validationData.routing_value1 ?
                  <Col lg={3} md={6} className="mb-4">
                    <BankAccountInput
                      id="routingValue"
                      labelValue="ABA Routing Number"
                      required={validationData.routing_value1?.required}
                      type={validationData.routing_value1?.type}
                      value={data.levelThree?.routingValue || ""}
                      placeholder="e.g. 123456789"
                      pattern={validationData.routing_value1?.pattern}
                      error={isInvalid("levelThree", "routingValue")}
                      errorMessage={validationData.routing_value1?.enMessage}
                      onChange={(event) => onChange(event, "levelThree", "routingValue")}
                    />
                    <small><i>This field available only for US and USD</i></small>
                  </Col>
                  :
                  <Col lg={3} md={6} className="mb-4">
                    <Label htmlFor="routingValue" className="text-muted text-truncate mb-0">
                      ABA Routing Number{checkAbaIsSisabled() === false ? "*" : ""}
                    </Label>
                    <Input
                      id="routingValue"
                      type="number"
                      disabled={checkAbaIsSisabled()}
                      placeholder="e.g. 123456789"
                      className={`form-control`}
                      value={data.levelThree?.routingValue || ""}
                      onChange={(event) => onChange(event, "levelThree", "routingValue")}
                    />
                    <small><i>This field available only for US and USD</i></small>
                  </Col>
              }
            </Row>
          </Col>
        }

      </Row>
      <hr className='mt-0' />
      <Row>
        {
          banks && banks.length ?
            <Col lg={3} md={6} className="mb-4">
              <Label htmlFor='bankName' className='text-muted text-truncate mb-0'>Select a Bank*</Label>
              <ReactSelectOption
                value={data.levelThree?.bankName}
                isSearchable={true}
                selectedValue={(() => {
                  const selectedValue = { ...banks.find(item => item.bankName === data.levelThree?.bankName) };
                  if (Object.keys(selectedValue).length) {
                    selectedValue.label = selectedValue.bankName;
                    selectedValue.value = selectedValue.bankName;
                    return selectedValue;
                  } else {
                    return { label: "Choose...", value: "" }
                  }
                })()}
                // items={banks.map(data => ({ label: data.bankName, bankCode: data.bankCode, bankName: data.bankName, swiftCode: data.swiftCode }))}
                items={banks.map(item => ({ label: item.bankName, ...item }))}
                onChange={(item) => onBankSelectOptionChange(item, "levelThree")}
              />
            </Col>
            : validationData && validationData.bank_name ?
              <Col lg={3} md={6} className="mb-4">
                <BankAccountInput
                  id="bankName"
                  labelValue="Bank Name"
                  required={validationData.bank_name?.required}
                  type={validationData.bank_name.type}
                  value={data.levelThree?.bankName || ""}
                  placeholder='e.g. Bank of America'
                  pattern={validationData.bank_name?.pattern}
                  error={isInvalid("levelThree", "bankName")}
                  errorMessage={validationData.bank_name?.enMessage}
                  onChange={(event) => onChange(event, "levelThree", "bankName")}
                />
              </Col>
              :
              <Col lg={3} md={6} className="mb-4">
                <Label htmlFor='bankName' className='text-muted text-truncate mb-0'>Bank Name*</Label>
                <Input
                  id="bankName"
                  type="text"
                  placeholder='e.g. Citibank'
                  className={`form-control`}
                  value={data.levelThree?.bankName || ""}
                  onChange={(event) => onChange(event, "levelThree", "bankName")}
                />
              </Col>
        }
        {
          validationData && validationData.bank_address ?
            <Col lg={3} md={6} className="mb-4">
              <BankAccountInput
                id="bankAddress"
                labelValue="Bank Address"
                required={validationData.bank_address?.required}
                type={validationData.bank_address.type}
                value={data.levelThree?.bankAddress || ""}
                placeholder='e.g. Bank of America, N.A., 222 Broadway, New York, NY 10038, United States'
                pattern={validationData.bank_address?.pattern}
                error={isInvalid("levelThree", "bankAddress")}
                errorMessage={validationData.bank_address?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "bankAddress")}
              />
            </Col>
            :
            <Col lg={3} md={6} className="mb-4">
              <Label htmlFor='bankAddress' className='text-muted text-truncate mb-0'>Bank Address*</Label>
              <Input
                id="bankAddress"
                type="text"
                placeholder='e.g. 789 Oak Road, Villageton, CA, 98765'
                className={`form-control`}
                value={data.levelThree?.bankAddress || ""}
                onChange={(event) => onChange(event, "levelThree", "bankAddress")}
              />
            </Col>
        }
        {
          validationData && validationData.bank_code ?
            <Col lg={3} md={6} className="mb-4">
              <BankAccountInput
                id="bankCode"
                labelValue="Bank Code"
                required={validationData.bank_code?.required}
                type={validationData.bank_code?.type}
                value={data.levelThree?.bankCode || ""}
                placeholder='e.g. 055'
                pattern={validationData.bank_code?.pattern}
                error={isInvalid("levelThree", "bankCode")}
                disabled={selectedBankAccount}
                errorMessage={validationData.bank_code?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "bankCode")}
              />
            </Col>
            :
            <Col lg={3} md={6} className="mb-4">
              <Label htmlFor='bankCode' className='text-muted text-truncate mb-0'>Bank Code*</Label>
              <Input
                id="bankCode"
                type="text"
                disabled={selectedBankAccount}
                placeholder='e.g. 123456'
                className={`form-control`}
                value={data.levelThree?.bankCode || ""}
                onChange={(event) => onChange(event, "levelThree", "bankCode")}
              />
            </Col>
        }
        {
          validationData && validationData.branch_code ?
            <Col lg={3} md={6} className="mb-4">
              <BankAccountInput
                id="branchCode"
                labelValue="Branch Code"
                required={validationData.branch_code?.required}
                type={validationData.branch_code?.type}
                value={data.levelThree?.branchCode || ""}
                placeholder='e.g. 055'
                pattern={validationData.branch_code?.type === "OPTION" ? "^[0-9]+$" : validationData.branch_code?.pattern}
                error={isInvalid("levelThree", "branchCode")}
                errorMessage={validationData.branch_code?.type === "OPTION" ? "The Input Content must contain only numeric characters" : validationData.branch_code?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "branchCode")}
              />
            </Col>
            :
            <Col lg={3} md={6} className="mb-4">
              <Label htmlFor='branchCode' className='text-muted text-truncate mb-0'>Branch Code*</Label>
              <Input
                id="branchCode"
                type="text"
                placeholder='e.g. 055'
                className={`form-control`}
                value={data.levelThree?.branchCode || ""}
                onChange={(event) => onChange(event, "levelThree", "branchCode")}
              />
            </Col>
        }
        {
          validationData && validationData.province ?
            <Col lg={3} md={6} className="mb-4">
              <BankAccountInput
                id="province"
                labelValue="State/Province"
                required={validationData.province?.required}
                type={validationData.province?.type}
                value={data.levelThree?.province || ""}
                placeholder='e.g. California'
                pattern={validationData.province?.pattern}
                error={isInvalid("levelThree", "province")}
                errorMessage={validationData.province?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "province")}
              />
            </Col>
            :
            <Col lg={3} md={6} className="mb-4">
              <Label htmlFor='province' className='text-muted text-truncate mb-0'>State/Province*</Label>
              <Input
                id="province"
                type="text"
                placeholder='e.g. California'
                className={`form-control`}
                value={data.levelThree?.province || ""}
                onChange={(event) => onChange(event, "levelThree", "province")}
              />
            </Col>
        }
        {
          validationData && validationData.city ?
            <Col lg={3} md={6} className="mb-4">
              <BankAccountInput
                id="city"
                labelValue="City"
                required={validationData.city?.required}
                type={validationData.city?.type}
                value={data.levelThree?.city || ""}
                placeholder='e.g. Los Angeles'
                pattern={validationData.city?.pattern}
                error={isInvalid("levelThree", "city")}
                errorMessage={validationData.city?.enMessage}
                onChange={(event) => onChange(event, "levelThree", "city")}
              />
            </Col>
            :
            <Col lg={3} md={6} className="mb-4">
              <Label htmlFor='city' className='text-muted text-truncate mb-0'>City*</Label>
              <Input
                id="city"
                type="text"
                placeholder='e.g. Los Angeles'
                className={`form-control`}
                value={data.levelThree?.city || ""}
                onChange={(event) => onChange(event, "levelThree", "city")}
              />
            </Col>
        }
      </Row>
    </Col>
  )
}
